import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";

import { getConfigItemByParentId } from "store/state/configItems";
import { ROUTE_DASHBOARD } from "constants/routes";
import { CONFIGURABLE_URLS } from "constants/configItemParents";
import SplashScreen from "../LoadingIndicator/SplashScreen";

import styled from "styled-components";
const Container = styled.div`
  height:calc(100vh - 75px);
`;

const landing = "dashboards/5f10b986dba4d32488349baa/?embed=true&l=false&r=false";
const reports = "dashboards/5f10b986dba4d32488349baa/?embed=false&l=true&r=true";
const getIframe = (isLanding, sisenseURL) =>
  `<iframe 
    id="ifm"
    name="ifm"
    width="100%"
    height="100%"
    frameborder="0"
    src="https://${sisenseURL}/app/main#/${isLanding ? landing : reports}"
    scrolling="auto"></iframe>`;

// browser detection taken from https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;
// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;

class Reports extends React.Component {
  state = {
    isInitializing: true
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isInitializing: false });
    }, 5500);

    this.props.getConfigItemByParentId({ id: CONFIGURABLE_URLS });
  }

  render() {
    if (!this.props.authentication || this.props.authentication.companyLevel === "" || !this.props.sisenseURL)
      return null;

    const isLanding = this.props.match.path === "/home";

    if (isEdge) {
      return (<Fragment>
        <h2>We're sorry. LoanBoss Reporting is not supported on your browser. Please use Chrome or Firefox instead.</h2>
      </Fragment>)
    } else {
      if (this.props.authentication && (this.props.authentication.companyLevel === "Professional"
        || this.props.authentication.companyLevel === "Enterprise"
        || this.props.authentication.companyLevel === "Secondary Sponsor")) {
        return (<>
          <Container dangerouslySetInnerHTML={{ __html: getIframe(isLanding, this.props.sisenseURL) }} />
          {(this.state.isInitializing || !this.props.authentication || this.props.authentication.companyLevel === "") &&
            <SplashScreen loading={this.state.isInitializing} />}
        </>);
      } else {
        return <Redirect to={ROUTE_DASHBOARD} />;
      }
    }
  }
}

const mapStateToProps = ({ authentication, configItems }) => ({
  authentication,
  sisenseURL: configItems &&
    configItems.configItemByParent[ CONFIGURABLE_URLS ] &&
    configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(x => x.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef").length > 0 ?
    configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(x => x.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef")[ 0 ].value : ""
});

export default compose(
  connect(
    mapStateToProps, {
    getConfigItemByParentId
  })
)(Reports);
